'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.AlertLooks = void 0;
(function(AlertLooks) {
    AlertLooks["Error"] = 'error';
    AlertLooks["None"] = 'none';
    AlertLooks["Success"] = 'success';
    AlertLooks["Warning"] = 'warning';
})(exports.AlertLooks || (exports.AlertLooks = {}));
exports.AlertTypes = void 0;
(function(AlertTypes) {
    AlertTypes["Assertive"] = 'assertive';
    AlertTypes["Polite"] = 'polite';
})(exports.AlertTypes || (exports.AlertTypes = {}));
//# sourceMappingURL=alert.js.map
